export function readCurrent<T>(cell: { readonly current: T }): T {
  return cell.current;
}
